import { OneOfListElements } from '@shared/models/project.model';
import { SectionRowContentProps } from '@ui/ElementList/list.model';
import { RowCell, ROOT_CELL_WIDTH, useListHover } from '@ui/ElementList';
import { Typography } from '@mui/material';
import { IconButton } from '@ui/buttons';
import { guards } from '@shared/helpers/typeguards.helpers';
import { GroupSectionMeta } from '../element-grouping.model';
import { SbefGroupSectionBarsAndMetrics } from './SbefGroupSectionBarsAndMetrics';
import { useCallback } from 'react';

export const ElementListSbefGroupRowContent = <T extends OneOfListElements>({
  section,
  expanded,
  isHovered = false,
  onExpandToggle,
}: SectionRowContentProps<T, GroupSectionMeta>) => {
  const { someRowIsHovered, setSomeRowIsHovered } = useListHover();
  const showMetrics = isHovered || someRowIsHovered;
  const showMetricIcons = isHovered;

  const handleMetricsAreaMouseEnter = useCallback(() => {
    setSomeRowIsHovered(true);
  }, [setSomeRowIsHovered]);

  const handleMetricsAreaMouseLeave = useCallback(() => {
    setSomeRowIsHovered(false);
  }, [setSomeRowIsHovered]);

  return (
    <>
      <RowCell gap={0} width={ROOT_CELL_WIDTH.CONTENT}>
        <IconButton
          category="mui"
          icon="ArrowDropDown"
          hidden={!isHovered}
          disabled={guards.is.undefined(onExpandToggle)}
          rotateIcon={expanded ? 0 : -90}
          shape="square"
          onClick={onExpandToggle}
        />
        <Typography
          component="span"
          variant="h6"
          sx={{
            textTransform: 'uppercase',
            userSelect: 'none',
          }}
        >
          {section.label}
        </Typography>
      </RowCell>

      <RowCell
        responsiveWidth={1}
        onMouseEnter={handleMetricsAreaMouseEnter}
        onMouseLeave={handleMetricsAreaMouseLeave}
      >
        <SbefGroupSectionBarsAndMetrics
          section={section}
          metricsVisible={showMetrics}
          showMetricIcons={showMetricIcons}
          showKebabSpacer
        />
      </RowCell>
    </>
  );
};
